import React from 'react';
import './MobileMenu.css';

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
  activeItem: string;
  onNavigate: (item: string) => void;
  pendingContracts?: number;
  isCommissioner?: boolean;
  userData?: any;
  isSignedIn?: boolean;
}

interface MenuItem {
  id: string;
  label: string;
  icon: string;
  route: string;
}

interface MenuSection {
  header?: string;
  items: MenuItem[];
}

const menuSections: MenuSection[] = [
  {
    items: [
      { id: 'home', label: 'Home', icon: '🏠', route: '/app' },
      { id: 'daily-reward', label: 'Daily Reward', icon: '🎁', route: '/daily-reward' },
      { id: 'finances', label: 'Finances', icon: '💰', route: '/finances' },
      { id: 'settings', label: 'Settings', icon: '⚙️', route: '/settings' },
    ],
  },
  {
    header: 'Traditional Leagues',
    items: [
      { id: 'traditional-leagues', label: 'Leagues', icon: '🏆', route: '/leagues' },
      { id: 'agent-office', label: 'My Players', icon: '⚾', route: '/players' },
      { id: 'owner-office', label: 'My Teams', icon: '🏟️', route: '/my-teams' },
      { id: 'forge', label: 'Forge', icon: '🔨', route: '/forge' },
      { id: 'marketplace', label: 'Marketplace', icon: '🏪', route: '/marketplace' },
      { id: 'free-agents', label: 'Free Agency', icon: '🆓', route: '/free-agents' },
    ],
  },
  {
    header: 'Quick Leagues',
    items: [
      { id: 'current-leagues', label: 'Leagues', icon: '⚡', route: '/quick-leagues' },
      { id: 'ql-lobby', label: 'Join a League', icon: '🎯', route: '/quick-league-lobby' },
      { id: 'ql-my-teams', label: 'My QL Teams', icon: '📋', route: '/ql-my-teams' },
      { id: 'team-builder', label: 'Team Builder', icon: '🏗️', route: '/team-builder' },
      { id: 'ql-top-owners', label: 'Top Owners', icon: '🏅', route: '/ql-top-owners' },
    ],
  },
];

const MobileMenu: React.FC<MobileMenuProps> = ({ 
  isOpen, 
  onClose, 
  activeItem, 
  onNavigate,
}) => {
  const handleNavigate = (item: MenuItem) => {
    onNavigate(item.route);
    onClose();
  };

  return (
    <>
      {isOpen && <div className="menu-overlay" onClick={onClose} />}
      
      <div className={`mobile-menu ${isOpen ? 'open' : ''}`}>
        <div className="mobile-menu-header">
          <h3>SimForge Baseball</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>

        <div className="mobile-menu-content">
          {menuSections.map((section, si) => (
            <div key={si} className="menu-section">
              {section.header && <span className="menu-section-label">{section.header}</span>}
              {section.items.map((item) => (
                <button
                  key={item.id}
                  className={`menu-item ${activeItem === item.id ? 'active' : ''}`}
                  onClick={() => handleNavigate(item)}
                >
                  <span className="menu-icon">{item.icon}</span>
                  <span className="menu-label">{item.label}</span>
                  {activeItem === item.id && <div className="active-indicator" />}
                </button>
              ))}
            </div>
          ))}

          <div className="menu-section" style={{ marginTop: 'auto' }}>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileMenu;
